import { render, staticRenderFns } from "./EquipmentBeyondTab.vue?vue&type=template&id=38821131&scoped=true"
import script from "./EquipmentBeyondTab.vue?vue&type=script&lang=js"
export * from "./EquipmentBeyondTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38821131",
  null
  
)

export default component.exports